import type { State } from '../types';
import type { LineItemsRecurringEstimate } from '../../ui/order-summary/src/components/types';

export function getLineItemsRecurringEstimate(state: State): LineItemsRecurringEstimate | null {
  const partnerPricing = state.recurringBillEstimate?.partnerPricing;
  if (!partnerPricing) {
    return null;
  }
  const totalExcludingDiscountAndTax = partnerPricing.totalExcludingDiscountAndTax;
  const totalListPrice = partnerPricing.totalListPrice;
  const totalAmountToPay = partnerPricing.grandTotal;
  const totalTax = partnerPricing.totalTax;
  const totalDiscountApplied = partnerPricing.totalDiscount;
  const totalPartnerMargin = partnerPricing.totalPartnerDiscount;
  const totalOtherDiscount = partnerPricing.totalOtherDiscount;
  const totalAdminFee = partnerPricing.totalAdminFee;

  return {
    totalExcludingDiscountAndTax: totalExcludingDiscountAndTax,
    totalListPrice: totalListPrice,
    totalAmountToPay: totalAmountToPay,
    totalTax: totalTax,
    totalDiscountApplied: totalDiscountApplied,
    totalPartnerDiscount: totalPartnerMargin,
    totalOtherDiscount: totalOtherDiscount,
    totalAdminFee: totalAdminFee,
  };
}
